// Sidebar navigation definition, rendered by SideBar.vue through SidebarItem.vue.
// - `menu`: MenuEnums id checked with ACCESS_MENU (also provides icon + title).
// - `to`: link target (top-level links only).
// - `routes`: route names that mark the entry as active.
// - `children`: submenu links ({ label, to, routes }); makes the entry a collapsible group.
import {
    MENU_HOME, MENU_AGENCY, MENU_OPERATORS, MENU_CONVEYORS, MENU_UNITS, MENU_SERVICES, MENU_RESERVATIONS,
    MENU_USERS, MENU_PROMOTIONS, MENU_BANKS, MENU_PROFILES, MENU_CASH_PAYMENT, MENU_PENDING_PAYMENTS, MENU_QUOTE
} from "@/enums/MenuEnums";
import {
    ROUTE_HOME,
    ROUTE_AGENCIES, ROUTE_AGENCIESADD, ROUTE_AGENCIESEDIT, ROUTE_AGENCIES_COMMISSIONS,
    ROUTE_USER_ADMIN, ROUTE_USER_ADD, ROUTE_USER_EDIT, ROUTE_USER_NOTIFICATIONS,
    ROUTE_OPERATORS, ROUTE_OPERATOR_ADD, ROUTE_OPERATOR_EDIT,
    ROUTE_TRANSPORTS, ROUTE_TRANSPORT_ADD, ROUTE_TRANSPORT_EDIT,
    ROUTE_UNITS,
    ROUTE_SERVICE_HOTELS, ROUTE_SERVICE_CIRCUITS, ROUTE_SERVICE_DAYTRIPS, ROUTE_SERVICE_TOURS,
    ROUTE_SERVICE_INTERNATIONALS, ROUTE_SERVICE_LOCKEDS, ROUTE_SERVICE_ADD_LOCKED, ROUTE_SERVICE_EDIT_LOCKED,
    ROUTE_SERVICE_GROUPS, ROUTE_SERVICE_ADD_GROUP, ROUTE_SERVICE_ADD, ROUTE_SERVICE_EDIT,
    ROUTE_SERVICE_TRAVEL_DATE, ROUTE_SERVICE_EXIT_PLACES, ROUTE_SERVICE_EXIT_PLACE_PRICES,
    ROUTE_SERVICE_QUOTE,
    ROUTE_RESERVATION_HOTEL_INDEX, ROUTE_RESERVATION_HOTEL_SHOW,
    ROUTE_RESERVATION_CIRCUIT_INDEX, ROUTE_RESERVATION_CIRCUIT_SHOW,
    ROUTE_RESERVATION_DAYTRIPS_INDEX, ROUTE_RESERVATION_DAYTRIPS_SHOW,
    ROUTE_RESERVATION_TOURS_INDEX, ROUTE_RESERVATION_TOURS_SHOW,
    ROUTE_RESERVATION_INTERNATIONALS_INDEX, ROUTE_RESERVATION_INTERNATIONALS_SHOW,
    ROUTE_RESERVATION_FLIGHTS_INDEX, ROUTE_RESERVATION_FLIGHTS_SHOW,
    ROUTE_RESERVATION_OTHER_SERVICE_INDEX, ROUTE_RESERVATION_OTHER_SERVICE_SHOW,
    ROUTE_RESERVATION_PACKAGED_INDEX, ROUTE_RESERVATION_PACKAGED_SHOW,
    ROUTE_RESERVATION_TRANSFER_INDEX, ROUTE_RESERVATION_TRANSFER_SHOW,
    ROUTE_RESERVATION_LOCKED_INDEX, ROUTE_RESERVATION_LOCKED_SHOW,
    ROUTE_RESERVATION_GROUP_INDEX, ROUTE_RESERVATION_GROUP_SHOW,
    ROUTE_RESERVATION_PAYMENT_TO_BROOKER,
    ROUTE_PROFILE_LIST, ROUTE_PROFILE_ADD, ROUTE_PROFILE_EDIT,
    ROUTE_BANKS, ROUTE_BANK_ADD, ROUTE_BANK_EDIT,
    ROUTE_PROMOTIONS, ROUTE_PROMOTION_ADD, ROUTE_PROMOTION_EDIT,
    ROUTE_CASH_PAYMENT,
    ROUTE_PENDING_PAYMENTS,
} from "@/enums/RouteNameEnums";

const serviceChildren = [
    { label: 'Hoteles', to: '/admin/servicios/hoteles', routes: [ROUTE_SERVICE_HOTELS] },
    { label: 'Circuitos', to: '/admin/servicios/circuitos', routes: [ROUTE_SERVICE_CIRCUITS] },
    { label: 'Pasadias', to: '/admin/servicios/pasadias', routes: [ROUTE_SERVICE_DAYTRIPS] },
    { label: 'Tours', to: '/admin/servicios/tours', routes: [ROUTE_SERVICE_TOURS] },
    { label: 'Internacionales', to: '/admin/servicios/internacionales', routes: [ROUTE_SERVICE_INTERNATIONALS] },
    { label: 'Bloqueos', to: '/admin/servicios/bloqueos', routes: [ROUTE_SERVICE_LOCKEDS, ROUTE_SERVICE_ADD_LOCKED, ROUTE_SERVICE_EDIT_LOCKED] },
    { label: 'Grupos', to: '/admin/servicios/grupos', routes: [ROUTE_SERVICE_GROUPS, ROUTE_SERVICE_ADD_GROUP] },
];

const reservationChildren = [
    { label: 'Hoteles', to: '/admin/reservaciones/hoteles', routes: [ROUTE_RESERVATION_HOTEL_INDEX, ROUTE_RESERVATION_HOTEL_SHOW] },
    { label: 'Circuitos', to: '/admin/reservaciones/circuitos', routes: [ROUTE_RESERVATION_CIRCUIT_INDEX, ROUTE_RESERVATION_CIRCUIT_SHOW] },
    { label: 'Pasadias', to: '/admin/reservaciones/pasadias', routes: [ROUTE_RESERVATION_DAYTRIPS_INDEX, ROUTE_RESERVATION_DAYTRIPS_SHOW] },
    { label: 'Tours', to: '/admin/reservaciones/tours', routes: [ROUTE_RESERVATION_TOURS_INDEX, ROUTE_RESERVATION_TOURS_SHOW] },
    { label: 'Internacionales', to: '/admin/reservaciones/internacionales', routes: [ROUTE_RESERVATION_INTERNATIONALS_INDEX, ROUTE_RESERVATION_INTERNATIONALS_SHOW] },
    { label: 'Vuelos', to: '/admin/reservaciones/vuelos', routes: [ROUTE_RESERVATION_FLIGHTS_INDEX, ROUTE_RESERVATION_FLIGHTS_SHOW] },
    { label: 'Otros Servicios', to: '/admin/reservaciones/otros-servicios', routes: [ROUTE_RESERVATION_OTHER_SERVICE_INDEX, ROUTE_RESERVATION_OTHER_SERVICE_SHOW] },
    { label: 'Empaquetados', to: '/admin/reservaciones/empaquetados', routes: [ROUTE_RESERVATION_PACKAGED_INDEX, ROUTE_RESERVATION_PACKAGED_SHOW] },
    { label: 'Traslados', to: '/admin/reservaciones/traslados', routes: [ROUTE_RESERVATION_TRANSFER_INDEX, ROUTE_RESERVATION_TRANSFER_SHOW] },
    { label: 'Bloqueos', to: '/admin/reservaciones/bloqueos', routes: [ROUTE_RESERVATION_LOCKED_INDEX, ROUTE_RESERVATION_LOCKED_SHOW] },
    { label: 'Grupos', to: '/admin/reservaciones/grupos', routes: [ROUTE_RESERVATION_GROUP_INDEX, ROUTE_RESERVATION_GROUP_SHOW] },
];

export default [
    { menu: MENU_HOME, to: '/admin/dashboard', routes: [ROUTE_HOME] },
    { menu: MENU_AGENCY, to: '/admin/agencias', routes: [ROUTE_AGENCIES, ROUTE_AGENCIESADD, ROUTE_AGENCIESEDIT, ROUTE_AGENCIES_COMMISSIONS] },
    { menu: MENU_OPERATORS, to: '/admin/operadoras', routes: [ROUTE_OPERATORS, ROUTE_OPERATOR_ADD, ROUTE_OPERATOR_EDIT] },
    { menu: MENU_CONVEYORS, to: '/admin/transportadoras', routes: [ROUTE_TRANSPORTS, ROUTE_TRANSPORT_ADD, ROUTE_TRANSPORT_EDIT] },
    { menu: MENU_UNITS, to: '/admin/unidades', routes: [ROUTE_UNITS] },
    {
        menu: MENU_SERVICES,
        routes: [
            ...serviceChildren.flatMap(child => child.routes),
            ROUTE_SERVICE_ADD, ROUTE_SERVICE_EDIT, ROUTE_SERVICE_TRAVEL_DATE,
            ROUTE_SERVICE_EXIT_PLACES, ROUTE_SERVICE_EXIT_PLACE_PRICES,
        ],
        children: serviceChildren,
    },
    { menu: MENU_QUOTE, to: '/admin/cotizador', routes: [ROUTE_SERVICE_QUOTE] },
    {
        menu: MENU_RESERVATIONS,
        routes: [
            ...reservationChildren.flatMap(child => child.routes),
            ROUTE_RESERVATION_PAYMENT_TO_BROOKER,
        ],
        children: reservationChildren,
    },
    { menu: MENU_PROMOTIONS, to: '/admin/promociones', routes: [ROUTE_PROMOTIONS, ROUTE_PROMOTION_ADD, ROUTE_PROMOTION_EDIT] },
    { menu: MENU_CASH_PAYMENT, to: '/admin/pagos-efectivo', routes: [ROUTE_CASH_PAYMENT] },
    { menu: MENU_PENDING_PAYMENTS, to: '/admin/pagos-por-confirmar', routes: [ROUTE_PENDING_PAYMENTS] },
    { menu: MENU_BANKS, to: '/admin/cuentas', routes: [ROUTE_BANKS, ROUTE_BANK_ADD, ROUTE_BANK_EDIT] },
    { menu: MENU_USERS, to: '/admin/administradores', routes: [ROUTE_USER_ADMIN, ROUTE_USER_ADD, ROUTE_USER_EDIT, ROUTE_USER_NOTIFICATIONS] },
    { menu: MENU_PROFILES, to: '/admin/perfiles', routes: [ROUTE_PROFILE_LIST, ROUTE_PROFILE_ADD, ROUTE_PROFILE_EDIT] },
];
